import { FindMappingByTypeResponseDtoType } from "~/gen/api"
import { useFindMappingByType } from "~/gen/api/hooks"

export const useFindMappingByTypeQuery = (
  type: FindMappingByTypeResponseDtoType
) => useFindMappingByType(type)
